import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../domain/theme';

export const Description = ({ text, fontColor }) => {
  const styles = {
    main: css`
      ${theme.font.family('regularWeb')};
      color: ${fontColor};
      font-size: 18px;
      font-weight: 400;
      line-height: 1.5;
      margin: 0 auto 20px;
      max-width: 1080px;
      text-align: center;
      letter-spacing: initial;
    `
  };

  return <p css={styles.main}>{text}</p>;
};

Description.defaultProps = {
  fontColor: 'black'
};

Description.propTypes = {
  text: PropTypes.string.isRequired,
  fontColor: PropTypes.string
};
